import { css } from 'lit';

export const styles = css`
  .hive-block-component.border.light .selected-style {
    border-radius: 8px;
    box-shadow: 0px 0px 0px 1px var(--hive-brand-color);
  }
  .hive-block-component.border.dark .selected-style {
    border-radius: 8px;
    box-shadow: 0px 0px 0px 1px var(--hive-brand-color);
  }
  @media print {
    .hive-block-component.border.light .selected-style,
    .hive-block-component.border.dark .selected-style {
      box-shadow: none;
    }
  }
`;
